'use strict';

var _words = require('../_internal/_words');

module.exports = kebabCase;
function kebabCase(string) {
  return _words(string).reduce(function (acc, word) {
    if (word !== '') {
      if (acc === '') return word.toLowerCase();
      return acc + '-' + word.toLowerCase();
    }
    return acc;
  }, '');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoutils/cjs/kebabCase/index.js
// module id = 196
// module chunks = 0